import React, { useEffect, useRef } from 'react';

const AD_CLIENT = 'ca-pub-6994607587681269';
// Set this to your AdSense ad-unit slot ID (a number) after approval.
// While empty, ads render nothing — so the placements below stay invisible until you go live.
const AD_SLOT = '8732255306';

function AdSlot({ slot = AD_SLOT, format = 'auto', style }) {
  const pushed = useRef(false);
  const isPremium = (typeof localStorage !== 'undefined') && localStorage.getItem('isPremium') === 'true';

  useEffect(() => {
    if (!slot || isPremium || pushed.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch (e) {
      // adsbygoogle script not ready yet — safe to ignore
    }
  }, [slot, isPremium]);

  // No ads for premium members, and nothing until a slot ID is configured
  if (!slot || isPremium) return null;

  return (
    <div style={{ textAlign: 'center', margin: '1.5rem auto', maxWidth: 728, ...style }}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={AD_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
}

export default AdSlot;
